module.exports = __webpack_public_path__ + "static/img/particle2.7b3f8706.png";